import { createSlice } from '@reduxjs/toolkit';
import { workScheduleQueryApi } from 'features/work-schedule/query';
import { WorkScheduleState } from 'features/work-schedule/types';

const initialState: WorkScheduleState = {
  workSchedule: [],
};

const workScheduleSlice = createSlice({
  name: 'workSchedule',
  initialState,
  reducers: {},
  extraReducers: builder => {
    const { getWorkScheduleList } = workScheduleQueryApi.endpoints;

    builder.addMatcher(
      getWorkScheduleList.matchFulfilled,
      (state, { payload }) => {
        state.workSchedule = payload;
      }
    );
  },
});

export default workScheduleSlice.reducer;
